interface IVisibility {
	changeEvent: string;
	state: string;
}

export class WindowVisibility {

	static isVisibleState = true;

	static visibility: IVisibility = null;

	static handlers: Function[] = [];

	static init() {
		if (!IS_SSR) {
			this.visibility = this.getVisibility();

			window.addEventListener('focus', this.onWindowFocus);
			window.addEventListener('blur', this.onWindowBlur);
			document.addEventListener(this.visibility.changeEvent, this.onWindowVisibilityChange);
		}
	}

	static destroy() {
		this.handlers = [];

		if (!IS_SSR) {
			window.removeEventListener('focus', this.onWindowFocus);
			window.removeEventListener('blur', this.onWindowBlur);
			document.removeEventListener(this.visibility.changeEvent, this.onWindowVisibilityChange);
		}
	}

	static isVisible() {
		return this.isVisibleState;
	}

	static getVisibility(): IVisibility {
		if (!IS_SSR) {
			const visibilityStates: { [visibilityState: string]: string } = {
				hidden: 'visibilitychange',
				webkitHidden: 'webkitvisibilitychange',
				mozHidden: 'mozvisibilitychange',
				msHidden: 'msvisibilitychange',
			};

			const visibilityState = Object.keys(visibilityStates)
				.find((visibilityState) => (window.document as unknown as { [key: string]: string })[visibilityState] !== undefined);

			return {
				changeEvent: visibilityStates[visibilityState],
				state: visibilityState,
			};
		}
	}

	static onWindowFocus() {
		WindowVisibility.isVisibleState = true;
	}

	static onWindowBlur() {
		WindowVisibility.isVisibleState = false;
	}

	static onWindowVisibilityChange() {
		if (!IS_SSR) {
			WindowVisibility.isVisibleState = !(window.document as unknown as { [key: string]: string })[WindowVisibility.visibility.state];

			WindowVisibility.handlers.forEach((handler: Function) => handler());
		}
	}

	static onChange(handler: Function) {
		if (!IS_SSR) {
			if (typeof handler === 'function') {
				this.handlers.push(handler);
			}
		}
	}

}
